<template>
  <span v-html="formattedValue"></span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    currencyCode: (window as any).currencyCode,
  }),
  computed: {
    formattedValue(): string {
      return `${this.currencyCode}${this.value.toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
  },
});
</script>
